import { Event, EventDispatcher } from "@planzone/events";
import { UseCases } from "@planzone/core";

const eventMap: Array<UseCases> = [
  UseCases.editPersonalWeeklyCalendar,
  UseCases.inviteMembers,
  UseCases.assignPersonalCalendarHolidays,
  UseCases.unAssignPersonalCalendarHolidays,
  UseCases.allocateResources,
  UseCases.editAllocation,
  UseCases.removeAllocation,
  UseCases.editAccessRestrictions,
  UseCases.updatePlanzoneContacts,
  UseCases.editOrganization,
  UseCases.editPlanzoneSettings,
  UseCases.editWbsConfiguration,
  UseCases.editProjectListingConfiguration,
  UseCases.assignDefaultCalendarHolidaysToPlanzone,
  UseCases.editProjectElementDetailsConfiguration,
  UseCases.editProjectDetailsConfiguration,
  UseCases.changePlanzoneLogo,
  UseCases.addProjectExternalLink,
  UseCases.editProjectExternalLink,
  UseCases.removeProjectExternalLink,
  UseCases.createList,
  UseCases.createEvent,
  UseCases.editEvent,
  UseCases.removeEvent,
  UseCases.createMilestone,
  UseCases.createTask,
  UseCases.createTaskStatus,
  UseCases.editList,
  UseCases.editMilestone,
  UseCases.editTask,
  UseCases.editTaskStatus,
  UseCases.markMilestoneAsCompleted,
  UseCases.markTaskAsCompleted,
  UseCases.moveKanbanTask,
  UseCases.moveListElement,
  UseCases.removeList,
  UseCases.removeTask,
  UseCases.removeTaskStatus,
  UseCases.removeMilestone,
  UseCases.duplicateList,
  UseCases.editProjectReportTemplate,
  UseCases.submitProjectReport,
  UseCases.removeProjectReport,
  UseCases.editProjectReport,
  UseCases.createProject,
  UseCases.editProject,
  UseCases.removeProject,
  UseCases.editProjectWeatherReport,
  UseCases.configureProjectTools,
  UseCases.useProjectModel,
  UseCases.createProjectModelFromProject,
  UseCases.duplicateProject,
  UseCases.createProjectStatus,
  UseCases.editProjectStatus,
  UseCases.removeProjectStatus,
  UseCases.addPlanzoneMaterialResource,
  UseCases.addPlanzoneVirtualResource,
  UseCases.addProjectMaterialResource,
  UseCases.addProjectVirtualResource,
  UseCases.addPlanzoneResourceToProject,
  UseCases.addPlanzoneResourcesToProject,
  UseCases.addEveryoneToProject,
  UseCases.removeResourceFromPlanzone,
  UseCases.editResource,
  UseCases.removeResourceFromProject,
  UseCases.editProjectResource,
  UseCases.editResourceWeeklyCalendar,
  UseCases.assignManagerToResource,
  UseCases.assignEveryoneToManager,
  UseCases.removeSubordinates,
  UseCases.unAssignManagerFromResource,
  UseCases.assignCalendarHolidaysToResource,
  UseCases.disableProjectResource,
  UseCases.activateProjectResource,
  UseCases.disableResource,
  UseCases.activateResource,
  UseCases.unAssignCalendarHolidaysFromResource,
  UseCases.addPlanzoneResourceToProjects,
  UseCases.changeProfilePicture,
  UseCases.transferProjectResourceAllocations,
  UseCases.addResourceGroup,
  UseCases.removeResourceGroup,
  UseCases.editResourceGroup,
  UseCases.addResourceToResourceGroup,
  UseCases.addEveryoneToResourceGroup,
  UseCases.removeResourceFromResourceGroup,
  UseCases.assignTag,
  UseCases.removeTag,
  UseCases.removeZone,
  UseCases.transferProjects,
  UseCases.createZone,
  UseCases.editZone,
  UseCases.postComment,
  UseCases.removeComment,
  UseCases.retrieveDiscussions,
  UseCases.startDiscussion,
  UseCases.removeDiscussion,
  UseCases.createProjectPortfolio,
  UseCases.assignProjectToPortfolio,
  UseCases.removeProjectPortfolio,
  UseCases.removeProjectFromPortfolio,
  UseCases.editProjectPortfolio,
  UseCases.markNotificationsAsRead,
  UseCases.uploadDocument,
  UseCases.createFolder,
  UseCases.removeFolder,
  UseCases.removeDocument,
  UseCases.downloadDocumentContent,
  UseCases.downloadFolderContent,
  UseCases.attachDocumentsToElement,
  UseCases.removeAttachedDocument,
  UseCases.moveDocument,
  UseCases.createDocument,
  UseCases.updateFolder,
  UseCases.copyDocument,
  UseCases.updateDocument,
  UseCases.moveFolder,
  UseCases.search,
  UseCases.saveTimeRecord,
  UseCases.validateTimeRecordsUpToDate,
  UseCases.validatePersonalTimeRecordsUpToDate,
  UseCases.createCostProfile,
  UseCases.editCostProfile,
  UseCases.removeCostProfile,
  UseCases.assignCostProfileToResource,
  UseCases.removeCostProfileFromResource,
  UseCases.removeCost,
  UseCases.editCost,
  UseCases.editProjectAllocatedBudget,
  UseCases.createProjectExpense,
  UseCases.createProjectExpenseType,
  UseCases.removeProjectExpense,
  UseCases.editProjectExpense,
  UseCases.editProjectAllocatedResourcesBudget,
  UseCases.editProjectAllocatedExpensesBudget,
  UseCases.constrainElements,
  UseCases.removeConstraint,
  UseCases.editConstraint,
  UseCases.createUnavailability,
  UseCases.editUnavailability,
  UseCases.removeUnavailability,
  UseCases.exportData,
  UseCases.createStrategicAxis,
  UseCases.removeStrategicAxis,
  UseCases.editStrategicAxis,
  UseCases.createProjectStrategicAxis,
  UseCases.editProjectStrategicAxis,
  UseCases.createCalendarExportLink,
  UseCases.retrieveCalendarExportLinks,
  UseCases.editSecondaryCriteriaTemplate,
  UseCases.createCalendarHolidays,
  UseCases.removeCalendarHolidays,
  UseCases.editCalendarHolidays,
  UseCases.removeHoliday,
];

function capitalize(str: string): Capitalize<keyof typeof UseCases> {
  return (str.charAt(0).toUpperCase() + str.slice(1)) as Capitalize<
    keyof typeof UseCases
  >;
}

function createWsPublisherDecorator(
  dispatcher: EventDispatcher,
  publish: (event: Event) => void,
): EventDispatcher {
  return Object.entries(dispatcher).reduce<EventDispatcher>(
    (decoratedDispatcher, [dispatch, method]) => ({
      ...decoratedDispatcher,
      [dispatch]: (data: any) => {
        method(data);

        try {
          const useCase = dispatch
            .replace("dispatch", "")
            .replace("Success", "");
          const foundUseCase = eventMap.find(
            (uc) => capitalize(uc) === useCase,
          );

          if (!!foundUseCase) {
            publish({
              type: `${foundUseCase}Succeeded`,
              data,
            } as Event);
          }
        } catch (e) {}
      },
    }),
    dispatcher,
  );
}

export { createWsPublisherDecorator };
